import React, { useState, useEffect, Fragment } from "react";
import {
  Row,
  Col,
  Text,
  Icon,
  Input,
  Radio,
  Modal,
  Popover,
  Menu,
  Dropdown,
} from "antd";
import ButtonComponent from "./Button_v2";
import ModalComponent from "./Modal_v2";
import ReusableInput from "../../stories/components/ReusableInput";
import { maxHeight40 } from "../../helpers/invoice_styles";
import Checkbox_v2 from "./Checkbox_v2";
import Select_v2 from "./Select_v2";
import OrderAccessorialForm from "../../components/orders/OrderAccessorialFrom";
import SectionCard from "./SectionCard";
import { FormIcon, ViewMore } from "../../common/CustomIcon";
import ErrorComponent from "../../components/common/ErrorComponent";
import I18n from "../../common/I18n";
import TrashIcon from "../../../assets/images/Trash.svg";
import NoteIcon from "../../../assets/images/Note.svg";
import { fetchTechnicians } from "../../api/UsersApi";
import CreateOrderAccessorial from "./CreateOrderAccessorial";
import { saveOrderAccessorials } from "../../api/OrdersApi";
import { getLabelDescriptionForLocation, renderNotification } from "../../components/orders/OrderTypeIcons";
import { setAccessorialResponse } from "../../helpers/orders";
import { isEmpty, randomNumber } from "../../common/Common";

const { confirm } = Modal;

function DispalyOrderAccessorial(props) {
  const {
    accountComponentAccessorial,
    config,
    haveMultipleLocations,
    displayComponents,
    isMilitaryTime = false,
    //accRef,
    updateOrderAccessorials,
    processingRecords = [],
    prevAuthorizedInfo = {},
    actionType = "create",
    currentOrder = {},
    location,
    accountId ='',
    drivers = [],
    currentOrg = {},
    maximumHeight = 'auto',
    isShipper = false,
    showActions = true,
    setEstimateRefreshKey = () => {},
    orderTypeConfig = {},
    refreshDetails
  } = props;
  const [orderAccessorials, setOrderAccessorials] = useState(location.accessorials ? [...location.accessorials] : []);
  const [authorizeDetails, setAuthorizeDetails] = useState({});
  const [errors, setErrors] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const accessorials = location.accessorials || [];
          const authorizeDetails = {}
          const allowedIds = {};
          accountComponentAccessorial.forEach(
            (accessorial) => {
              const components = accessorial.components ? 
              accessorial.components.map(record => record.component_code)
              :
              [];
              allowedIds[accessorial.id] = [...components];
          })
          const orderAccessorialsInfo = setAccessorialResponse(
            accessorials,
            true,
            allowedIds,
          )
          orderAccessorialsInfo.forEach(rec => {
            if(!isEmpty(rec.authorized_by)){
              authorizeDetails[rec.accessorial_code] = {
                authorized_by: rec.authorized_by,
                authorization_code: rec.authorization_code,
                comments: rec.comments,
                is_modified: false,
              }
            }
          })
          setAuthorizeDetails(authorizeDetails)
          setOrderAccessorials(orderAccessorialsInfo)
  }, [location.accessorials, accountComponentAccessorial, displayComponents])

  const handleSave = (records, cb = null, setChildErrors = () => {}, errorCb = null) => {
    setIsLoading(true);
    const data = {
      organization_id: currentOrg?.id || '',
      account_id: accountId,
      customer_order_id: currentOrder?.id || '',
      location_id: location?.id || '',
      account_accessorial_params: [...records],
      }
      saveOrderAccessorials(data).then((result) => {
        if (result.success) {
          setIsLoading(false);
          setOrderAccessorials([...records])
          renderNotification(I18n.t('messages.saved'), 'success')
          if(cb){
            cb();
          }
          refreshDetails?.()
          setEstimateRefreshKey(randomNumber())
        } else {
          setChildErrors(result.errors)
          setIsLoading(false);
          if(errorCb){
            errorCb();
          }
        }
      })
  }
  

  return (
    <CreateOrderAccessorial
      // getDataRef={accessorialRef.current[index]}
      accountComponentAccessorial={accountComponentAccessorial || []}
      config={config}
      haveMultipleLocations={haveMultipleLocations}
      displayComponents={displayComponents || []}
      title={getLabelDescriptionForLocation(location.label_code, orderTypeConfig?.extraCode || orderTypeConfig?.code)}
      //accRef={accessorialRef}
      drivers={drivers}
      updateOrderAccessorials={handleSave}
      processingRecords={orderAccessorials}
      prevAuthorizedInfo={authorizeDetails}
      actionType={"view"}
      currentOrg={currentOrg}
      accountId={accountId}
      maximumHeight={maximumHeight}
      showActions={showActions}
      isShipper={isShipper}
      loading={isLoading}
      currentOrder={currentOrder}
    />
  );
}
export default DispalyOrderAccessorial;
